import { useTranslation } from "react-i18next";
import { Abstract3DShapes } from "@/components/decorative";
import { Linkedin, ChevronDown, ChevronRight } from "lucide-react";
import saskiaProfile from "@/assets/team/saskia-profile.png";
import jeroenProfile from "@/assets/team/jeroen-profile.png";
import adProfile from "@/assets/team/ad-profile.png";
import aukeProfile from "@/assets/team/auke-profile.png";
import brittProfile from "@/assets/team/britt-profile.png";
import mayraProfile from "@/assets/team/mayra-profile.png";
import { useState } from "react";
export const WhosBehind = () => {
  const {
    t
  } = useTranslation();
  const [isCreditsExpanded, setIsCreditsExpanded] = useState(false);
  const teamMembers = [{
    name: "Jeroen Wilms",
    title: "cpo",
    linkedIn: "https://www.linkedin.com/in/jeroenwilms/",
    image: jeroenProfile
  }, {
    name: "Saskia Rotshuizen",
    title: "ceo",
    linkedIn: "https://www.linkedin.com/in/saskiarotshuizen/",
    image: saskiaProfile
  }];
  const designTeam = [{
    name: "Ad Korf",
    title: "socialDesign",
    linkedIn: "#",
    image: adProfile
  }, {
    name: "Auke Lastname",
    title: "uxDesign",
    linkedIn: "#",
    image: aukeProfile
  }, {
    name: "Britt Prins",
    title: "visualDesign",
    linkedIn: "#",
    image: brittProfile
  }, {
    name: "Mayra Kaptein",
    title: "digitalDesign",
    linkedIn: "#",
    image: mayraProfile
  }];
  const contributors = ["B Lab Benelux", "Best3Minutes", "Bonnie Lastname", "Brad van Stone", "Brendon Lastname", "Carlotta Lastname", "Claudia de Barros", "Dominique van Straaten", "Dopper", "Edwin de Zeeuw", "Els Versteeg", "Emma Uitenthuis", "Emma Thunissen", "Erik de Rijk", "Erwin Rotshuizen", "Erwin StoryConnect Lastname", "Floor Lastname", "Frans-Willem Lastname", "GreenBoy", "Harry Verwayen", "Ian Lastname", "Ilse Kwaaitaal", "Impact Hub Amsterdam", "Jeljer Haarsma", "Joey van den Brink", "Johan Lastname", "Jos van Oosten", "Kirsten van Berkel", "Lena Kleine-Kalmer", "Lodewijk Hartman", "Luc Hillige", "Manon Klein", "Marco Konings", "Marijn Mennes", "Merel Philipaart", "Michael Edson", "Narrate", "Neilla Lastname", "Oscar Bastiaens", "Owen Lastname", "Peter Fechter", "Rik Ecochain Lastname", "Robert-Niels van Droffelaar", "Roel Ecochain Lastname", "Roos Spekman", "Rosanne Lastname", "Sigolien Lastname", "Sophie Lastname", "Tatiana Glad", "Tessa van Soest", "Toby Lastname", "Willicroft", "Luan & Nalu"];
  return <section id="whos-behind" className="py-16 md:py-24 px-4">
        <div className="container mx-auto max-w-6xl">
          <h2 className="font-clash text-3xl xs:text-4xl md:text-5xl font-bold text-center mb-2 text-foreground tracking-tight">
            {t("whosBehind.headline")}
          </h2>
          <p className="text-center text-lg text-muted-foreground mb-12">
            and know their sh!t
          </p>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left: Logos and Endorsement */}
            <div className="text-center lg:text-left space-y-6">
              <div>
                <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                  {t("whosBehind.teamBio")}
                </p>

                <div className="space-y-6">
                  {/* Design Team */}
                  <div className="space-y-2">
                    <p className="text-sm font-semibold text-foreground">
                      Design team:
                    </p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center lg:justify-items-start">
                      {designTeam.map(member => <a key={member.name} href={member.linkedIn} target="_blank" rel="noopener noreferrer" className="group relative">
                          <div className="relative w-24 h-24 rounded-full overflow-visible ring-2 ring-brand-teal/30 group-hover:ring-brand-teal transition-all duration-150 bg-background">
                            <img src={member.image} alt={member.name} className="w-full h-full object-cover rounded-full" />
                            {/* LinkedIn Badge - Overlay on bottom-right edge */}
                            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-[#0077B5] rounded-full flex items-center justify-center z-10 ring-2 ring-background">
                              <Linkedin className="w-3 h-3 text-white" fill="white" />
                            </div>
                          </div>
                          <div className="text-center mt-2">
                            <p className="font-clash text-sm text-muted-foreground group-hover:text-foreground transition-colors duration-150">
                              {member.name}
                            </p>
                            <p className="text-xs text-muted-foreground/70 group-hover:text-muted-foreground transition-colors duration-150">
                              {t(`whosBehind.titles.${member.title}`)}
                            </p>
                          </div>
                        </a>)}
                    </div>
                  </div>

                  {/* Founding Team */}
                  <div className="space-y-2">
                  <p className="text-sm font-semibold text-foreground">Founders:</p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center lg:justify-items-start">
                    {teamMembers.map(member => <a key={member.name} href={member.linkedIn} target="_blank" rel="noopener noreferrer" className="group relative">
                        <div className="relative w-24 h-24 rounded-full overflow-visible ring-2 ring-brand-teal/30 group-hover:ring-brand-teal transition-all duration-150 bg-background">
                          <img src={member.image} alt={member.name} className="w-full h-full object-cover rounded-full" />
                          {/* LinkedIn Badge - Overlay on bottom-right edge */}
                          <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-[#0077B5] rounded-full flex items-center justify-center z-10 ring-2 ring-background">
                            <Linkedin className="w-3 h-3 text-white" fill="white" />
                          </div>
                        </div>
                        <div className="text-center mt-2">
                          <p className="font-clash text-sm text-muted-foreground group-hover:text-foreground transition-colors duration-150">
                            {member.name}
                          </p>
                          <p className="text-xs text-muted-foreground/70 group-hover:text-muted-foreground transition-colors duration-150">
                            {t(`whosBehind.titles.${member.title}`)}
                          </p>
                        </div>
                      </a>)}
                  </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Abstract 3D Shapes */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md aspect-square">
                <Abstract3DShapes density="dense" />
                
                {/* Central glow effect */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-40 h-40 bg-brand-teal/20 rounded-full blur-3xl animate-glow" />
                </div>
              </div>
            </div>
          </div>

          {/* Credits Section - Full Width */}
          <div className="pt-12 text-left space-y-3">
            <div className="flex flex-wrap items-center gap-2 justify-start">
              <a href="https://momentumlab.earth" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
                {t("footer.project")}
              </a>
              <span className="text-sm text-muted-foreground">•</span>
              <button onClick={() => setIsCreditsExpanded(!isCreditsExpanded)} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150 flex items-center gap-2">
                We give credit where credit is due
                {isCreditsExpanded ? (
                  <ChevronDown className="h-4 w-4 transition-transform duration-200" />
                ) : (
                  <ChevronRight className="h-4 w-4 transition-transform duration-200" />
                )}
              </button>
            </div>
            
            {/* Expandable Contributors List */}
            {isCreditsExpanded && <div className="pt-2 animate-in fade-in slide-in-from-top-2 duration-200">
                <p className="text-xs text-muted-foreground">
                  We're very grateful for the contributions and inspirations: {contributors.join(" • ")}
                </p>
              </div>}
          </div>
        </div>
      </section>;
};